import React from 'react';
import { Row } from 'reactstrap';
import DonutContainer from 'components/donut/DonutContainer';
import TrendContainer from 'components/trends/TrendContainer';

const page = 'my-insights';
let displayPageName = 'My Insights';

class EntertainmentOverview extends React.Component {
    state2 = {};
    render() {
        return (
            <div>
                <TrendContainer
                    path={this.props.path}
                    appliedFilters={this.props.appliedFilters}
                    allowedApps={['applications']}
                    forceReloadAll={this.props.forceReloadAll}
                    usageSource="ApplicationTrends"
                    title="Application Trends"
                    workbenchTitle="applications"
                    page={page}
                    pageName={displayPageName}
                    key="my_insights_overview_trend_applications_1"
                    id="my_insights_overview_trend_applications_1"
                    showWorkbenchLink={this.props.showWorkbench}
                    tenantIcaoCode={this.props.tenantIcaoCode}
                    app={this.props.app}
                />

                <Row>
                    <DonutContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        renderType="row"
                        page={page}
                        pageName={displayPageName}
                        forceReloadAll={this.props.forceReloadAll}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        allowedApps={this.props.allowedApps}
                        app={this.props.app}
                        isApplicationUsage={true}
                    />
                </Row>

                <TrendContainer
                    path={this.props.path}
                    appliedFilters={this.props.appliedFilters}
                    allowedApps={this.props.allowedApps}
                    forceReloadAll={this.props.forceReloadAll}
                    usageSource="EntertainmentTrends"
                    title="Entertainment Trends"
                    workbenchTitle="trends"
                    page={page}
                    pageName={displayPageName}
                    key="my_insights_overview_trend_1"
                    id="my_insights_overview_trend_1"
                    showWorkbenchLink={this.props.showWorkbench}
                    tenantIcaoCode={this.props.tenantIcaoCode}
                    app={this.props.app}
                />

                <Row>
                    <DonutContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        renderType="row"
                        page={page}
                        pageName={displayPageName}
                        forceReloadAll={this.props.forceReloadAll}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        allowedApps={this.props.allowedApps}
                        app={this.props.app}
                    />
                </Row>
            </div>
        );
    }
}

export default EntertainmentOverview;
